module.exports = __webpack_public_path__ + "static/media/unevenshoulder_mild_right.7b9e56f2.png";